<template>
  <div class="card-container">
    <Tabs type="card" v-model:active-key="state.activeKey">
      <TabPane :key="0" tab="未完成订单"></TabPane>
      <TabPane :key="1" tab="未出行订单"></TabPane>
      <TabPane :key="2" tab="历史订单"></TabPane>
    </Tabs>
  </div>
  <Card :bordered="false" class="filter-bar" :style="{ margin: '0 0 12px' }">
    <Form layout="inline">
      <FormItem label="乘车日期">
        <RangePicker v-model:value="state.dateRange" style="width: 260px" />
      </FormItem>
      <FormItem label="订单号/车次/姓名">
        <Input
          v-model:value="state.keywordDraft"
          allow-clear
          placeholder="支持模糊查询"
          style="width: 220px"
          @press-enter="onFilterSearch"
        />
      </FormItem>
      <FormItem label="状态">
        <Select
          v-model:value="state.statusDraft"
          :options="statusOptions"
          style="width: 160px"
        />
      </FormItem>
      <FormItem>
        <Space>
          <Button type="primary" @click="onFilterSearch">查询</Button>
          <Button @click="onFilterReset">重置</Button>
        </Space>
      </FormItem>
    </Form>
  </Card>
  <Card :bordered="false" :style="{ padding: '0 10px' }">
    <Table
      :columns="state.columns"
      :data-source="state.dataSource"
      :pagination="false"
      :loading="state.loading"
      :bordered="true"
      :row-class-name="getRowClassName"
    >
      <template #id="{ text, record }">
        <div class="passenger-info">
          <span class="passenger-name">{{ record?.realName }}</span>
          <span class="passenger-id-type">
            {{
              ID_CARD_TYPE.find((item) => item.value === record?.idType)?.label
            }}
          </span>
          <span class="passenger-status">{{ getPassengerStatusLabel(record) }}</span>
        </div>
      </template>
        <template #seatType="{ text, record }">
          <div>
            {{
              SEAT_CLASS_TYPE_LIST.find(
                (item) => item.code === record?.seatType
              )?.label
            }}
          </div>
          <div>{{ formatSeatSecondLine(record) }}</div>
        </template>
        <template #amount="{ text, record }">
          <div>
            {{
              TICKET_TYPE_LIST.find((item) => item.value === record?.ticketType)
                ?.label
            }}
            <Tag v-if="discountTag(record)" color="red" :bordered="true" class="disc-tag">{{
              discountTag(record)
            }}</Tag>
          </div>
          <template v-if="buildOrderPriceLines(record).length">
            <div
              v-for="(line, idx) in buildOrderPriceLines(record)"
              :key="idx"
              :class="line.highlight ? 'price-line-highlight' : 'price-line'"
            >
              {{ line.label }} <span :style="{ color: line.highlight ? 'orange' : '#666' }">{{ line.value }}</span>
            </div>
          </template>
          <div v-else :style="{ color: 'orange' }">￥{{ record?.amount / 100 }}</div>
        </template>
        <!-- 车票状态列由 columns.customRender（OrderStatusCell）渲染 -->
    </Table>
    <div
      :style="{
        width: '100%',
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'end'
      }"
    >
      <Pagination
        :key="`order-list-page-${state.activeKey}-${state.filterVersion}`"
        :show-total="(total) => `总共 ${state.data?.total} 条`"
        :current="state.current"
        :size="state.size"
        :total="state.data?.total"
        show-size-changer
        @change="handlePage"
      ></Pagination>
    </div>
    <div class="tips-txt">
      <h2 :style="{ fontSize: '16px' }">温馨提示：</h2>
      <p>1. 席位已锁定，请在指定时间内完成网上支付。</p>
      <p>2. 逾期未支付，系统将取消本次交易。</p>
      <p>3. 在完成支付或取消订单之前，您将无法购买其他车票</p>
      <p>
        4.
        未尽事宜详见《国铁集团铁路旅客运输规程》《广深港高铁铁路跨境旅客运输组织规则》《中老铁路跨境旅客联运组织规则》等有关规定和车站公告。
      </p>
    </div>
  </Card>
  <Modal
    :width="780"
    :visible="state.visible"
    title="办理退票"
    wrap-class-name="refund-modal"
    @cancel="state.visible = false"
    :footer="null"
  >
    <Alert
      message="请确认是否办理退票？"
      type="warning"
      description="如已订餐饮·特产等联订服务，请按规定在网站或车站另行办理退订。"
      show-icon
      class="refund-alert"
    >
      <template #icon><QuestionCircleFilled /></template>
    </Alert>

    <div class="refund-modal-body">
      <div class="refund-passenger-block">
        <div class="refund-passenger-label">请选择需办理退票的乘车人：</div>
        <CheckboxGroup
          v-model:value="state.refundOrder"
          :options="refundablePassengerOptions"
          class="refund-passenger-group"
        />
        <div
          v-if="state.currentOrder && !refundablePassengerOptions.length"
          class="refund-passenger-empty"
        >
          当前没有可退票的乘车人
        </div>
      </div>

      <div class="refund-fee-section">
        <Spin :spinning="state.refundFeeLoading">
          <RefundRescheduleFeePanel
            v-if="state.refundFeeData?.available"
            mode="refund"
            inline
            title="退票费用"
            :pending-selection="selectedRefundFee.pendingSelection"
            :ticket-price-yuan="selectedRefundFee.ticketPriceYuan ?? 0"
            :refund-fee-yuan="selectedRefundFee.refundFeeYuan ?? 0"
            :refund-service-fee-yuan="selectedRefundFee.refundServiceFeeYuan ?? 0"
            :refund-amount-yuan="selectedRefundFee.refundAmountYuan ?? 0"
            @show-rules="state.rulesModalVisible = true"
          />
          <div
            v-else-if="!state.refundFeeLoading && state.refundFeeTried"
            class="refund-fee-placeholder"
          >
            {{ state.refundFeeData?.message || '暂无法获取费用，具体费用请联系客服' }}
          </div>
          <div v-else-if="!state.refundFeeLoading" class="refund-fee-placeholder">
            正在查询退票费用…
          </div>
        </Spin>
      </div>
    </div>

    <div class="refund-footer-note">
      <QuestionCircleFilled />
      <span>办理联程、接续车票退票的，请不晚于票面开车时间前办理（具体以《铁路旅客运输规程》为准）。</span>
    </div>

    <RefundRescheduleRulesModal v-model:visible="state.rulesModalVisible" />
    <Space class="refund-actions">
      <Button @click="state.visible = false">取消</Button>
      <Button
        @click="handleRefund"
        type="primary"
        :disabled="!state.refundOrder.length"
        >确认退票</Button
      >
    </Space>
  </Modal>
</template>

<script setup>
import {
  Tabs,
  TabPane,
  Table,
  Card,
  Pagination,
  message,
  CheckboxGroup,
  Modal,
  Alert,
  Space,
  Button,
  Form,
  FormItem,
  RangePicker,
  Input,
  Select,
  Tag,
  Spin
} from 'ant-design-vue'
import { QuestionCircleFilled } from '@ant-design/icons-vue'

import CarInfo from './components/show-card-info'
import EditContent from './components/edit-content'
import OrderStatusCell from './components/order-status-cell'
import RefundRescheduleFeePanel from '@/components/refund-reschedule/RefundRescheduleFeePanel.vue'
import RefundRescheduleRulesModal from '@/components/refund-reschedule/RefundRescheduleRulesModal.vue'
import { fetchTicketList, fetchOrderCancel, fetchRefundTicket, fetchRefundFeeEstimate } from '@/service'
import { reactive, watch, h, onActivated, computed } from 'vue'
import {
  ID_CARD_TYPE,
  SEAT_CLASS_TYPE_LIST,
  TICKET_TYPE_LIST,
  TICKET_STATUS_LIST,
  ARCHIVE_ONLY_STATUS_FILTER,
  getOrderListStatusOptions
} from '@/constants'
import Cookie from 'js-cookie'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import { formatSeatSecondLine, formatDiscountTag } from '@/utils/orderDisplay'
import { sumSelectedRefundFee } from '@/utils/refundFeeEstimate'
import { buildRefundFeeSnapshot } from '@/utils/feeSnapshot'
import { buildOrderPriceLines } from '@/utils/orderPriceDisplay'

const userId = Cookie.get('userId')
const route = useRoute()
const router = useRouter()

const resolveListStateFromRoute = () => {
  const orderSn = route.query.orderSn ? String(route.query.orderSn).trim() : ''
  const tabRaw = route.query.tab
  const tab = tabRaw != null && tabRaw !== '' ? Number(tabRaw) : null
  let activeKey = 0
  if (Number.isFinite(tab)) {
    activeKey = tab
  } else if (orderSn) {
    activeKey = 1
  }
  return {
    activeKey,
    keyword: orderSn,
    keywordDraft: orderSn
  }
}

const routeListInit = resolveListStateFromRoute()

const state = reactive({
  activeKey: routeListInit.activeKey,
  dataSource: [],
  data: null,
  current: 1,
  size: 10,
  loading: false,
  columns: [],
  visible: false,
  currentOrder: undefined,
  refundOrder: [],
  dateRange: [],
  keyword: routeListInit.keyword,
  keywordDraft: routeListInit.keywordDraft,
  status: '',
  statusDraft: '',
  filterVersion: routeListInit.keyword ? 1 : 0,
  rulesModalVisible: false,
  refundFeeLoading: false,
  refundFeeTried: false,
  refundFeeData: null
})

const applyRouteListQuery = () => {
  const orderSn = route.query.orderSn ? String(route.query.orderSn).trim() : ''
  const tabRaw = route.query.tab
  if (!orderSn && (tabRaw == null || tabRaw === '')) return

  const nextActiveKey =
    tabRaw != null && tabRaw !== '' && Number.isFinite(Number(tabRaw))
      ? Number(tabRaw)
      : orderSn
        ? 1
        : state.activeKey

  let needRefresh = false
  if (state.activeKey !== nextActiveKey) {
    state.activeKey = nextActiveKey
    needRefresh = true
  }
  if (orderSn && (state.keyword !== orderSn || state.keywordDraft !== orderSn)) {
    state.keywordDraft = orderSn
    state.keyword = orderSn
    state.current = 1
    needRefresh = true
  }
  if (needRefresh) {
    state.filterVersion += 1
  }
}

onActivated(applyRouteListQuery)

const statusOptions = computed(() => getOrderListStatusOptions(state.activeKey))

watch(
  () => [route.query.orderSn, route.query.tab],
  () => {
    applyRouteListQuery()
  }
)

const getOrderRow = (orderSn) =>
  state.dataSource?.find((item) => item.orderSn === orderSn)

/** 改签子单(22/36)明细为改签票22；原单明细为已出票3/改签失败23，已改签50不可在原单退 */
const isRescheduleChildOrder = (orderSn) => {
  const os = getOrderRow(orderSn)?.orderStatus
  return os === 22 || os === 36
}

const isRefundablePassengerStatus = (orderSn, status) => {
  if (isRescheduleChildOrder(orderSn)) return status === 22
  return status === 3 || status === 23
}

const getRefundablePassengers = (orderSn) => {
  const details = getOrderRow(orderSn)?.passengerDetails || []
  return details.filter((p) => isRefundablePassengerStatus(orderSn, p.status))
}

const refundablePassengerOptions = computed(() =>
  getRefundablePassengers(state.currentOrder).map((item) => ({
    label: item.realName,
    value: item.id
  }))
)

const selectedRefundFee = computed(() =>
  sumSelectedRefundFee(
    state.refundFeeData,
    state.refundOrder,
    getRefundablePassengers(state.currentOrder)
  )
)

const loadRefundFeeEstimate = (orderSn) => {
  if (!orderSn) return
  state.refundFeeLoading = true
  state.refundFeeTried = false
  state.refundFeeData = null
  fetchRefundFeeEstimate({ orderSn })
    .then((res) => {
      state.refundFeeData = res?.data ?? null
    })
    .catch(() => {
      state.refundFeeData = {
        available: false,
        message: '暂无法获取费用，具体费用请联系客服'
      }
    })
    .finally(() => {
      state.refundFeeLoading = false
      state.refundFeeTried = true
    })
}

const openRefundModal = (orderSn) => {
  state.refundOrder = []
  state.currentOrder = orderSn
  state.visible = true
  loadRefundFeeEstimate(orderSn)
  loadTicketList()
}

const discountTag = (record) => formatDiscountTag(record)

const getPassengerStatusLabel = (record) => {
  const status =
    record?.passengerStatus ?? record?.status ?? record?.orderStatus
  return TICKET_STATUS_LIST.find((item) => item.value === status)?.label ?? '--'
}

const getRowClassName = (record) => {
  const s = record?.orderStatus ?? record?.status
  if (s === 31 || s === 32 || s === 34) return 'row-reschedule-status'
  return ''
}

const onFilterSearch = () => {
  state.keyword = (state.keywordDraft || '').trim()
  if (state.statusDraft === '' || state.statusDraft == null) {
    state.status = ''
  } else {
    const value = Number(state.statusDraft)
    state.status = Number.isFinite(value) ? value : ''
  }
  state.current = 1
  state.filterVersion += 1
}

const onFilterReset = () => {
  state.dateRange = []
  state.keywordDraft = ''
  state.keyword = ''
  state.statusDraft = ''
  state.status = ''
  state.filterVersion += 1
  state.current = 1
}

const columns = [
  {
    title: '车次信息',
    dataIndex: 'arrival',
    key: 'arrival',
    slots: { customRender: 'info' },
    customRender: ({ text, record }) => {
      return {
        children: h(CarInfo, {
          trainNumber: record?.trainNumber,
          orderTime: record?.orderTime,
          arrival: record?.arrival,
          departure: record?.departure,
          ridingDate: record?.ridingDate,
          departureTime: record?.departureTime,
          orderSn: record?.orderSn,
          showDetailLink: Number(record?.rowSpan) > 0
        }),
        props: {
          rowSpan: record?.rowSpan
        }
      }
    }
  },
  {
    title: '旅客信息',
    dataIndex: 'id',
    key: 'id',
    slots: { customRender: 'id' }
  },
  {
    title: '席位信息',
    dataIndex: 'seatType',
    key: 'seatType',
    slots: { customRender: 'seatType' }
  },
  {
    title: '票价',
    dataIndex: 'amount',
    key: 'amount',
    slots: { customRender: 'amount' }
  },
  {
    title: '车票状态',
    dataIndex: 'status',
    key: 'status',
    customRender: ({ record }) => {
      return {
        children: h(OrderStatusCell, {
          record,
          activeKey: state.activeKey,
          onRefund: () => openRefundModal(record?.orderSn)
        }),
        props: {
          rowSpan: record?.rowSpan
        }
      }
    }
  }
]

watch(
  () => state.activeKey,
  (newValue, oldValue) => {
    if (oldValue != null && newValue !== oldValue) {
      state.statusDraft = ''
      state.status = ''
      state.current = 1
    }
    if (newValue === 0) {
      state.columns = [
        ...columns,
        {
          title: '操作',
          dataIndex: 'edit',
          key: 'edit',
          slots: { customRender: 'edit' },
          customRender: ({ text, record }) => {
            // 当车票状态为1时，不显示操作按钮
            if (record?.status === 1 || record?.status === 2) {
              return {
                children: null,
                props: {
                  rowSpan: record?.rowSpan
                }
              }
            }
            return {
              children: h(EditContent, {
                orderSn: record?.orderSn,
                cancel,
                pay
              }),
              props: {
                rowSpan: record?.rowSpan
              }
            }
          }
        }
      ]
    } else {
      state.columns = columns
    }
  },
  { immediate: true }
)
const handlePage = (page, pagesize) => {
  if (page === state.current && pagesize === state.size) {
    return
  }
  state.current = page
  state.size = pagesize
}

/** 列表请求序号，丢弃过期的并发响应 */
let listRequestSeq = 0

const applyTicketListResponse = (res, statusFilter, statusType) => {
  const records = filterRecordsByOrderStatus(
    res.data?.records ?? [],
    statusFilter,
    statusType
  )
  let dataSource = buildDataSourceFromRecords(records)
  dataSource =
    statusFilter != null
      ? applyRowSpan(dataSource)
      : groupAndSortOrders(dataSource)

  state.dataSource = dataSource
  state.data = res.data
}

const loadTicketList = () => {
  const seq = ++listRequestSeq
  state.loading = true
  const statusType = state.activeKey
  const current = state.current
  const size = state.size
  const params = {
    userId,
    current,
    size,
    statusType
  }
  if (state.keyword) params.keyword = state.keyword
  const statusFilter = getActiveStatusFilter()
  if (statusFilter != null) {
    params.orderStatus = statusFilter
  }
  if (state.dateRange?.length === 2 && state.dateRange[0] && state.dateRange[1]) {
    params.ridingDateStart = dayjs(state.dateRange[0]).format('YYYY-MM-DD')
    params.ridingDateEnd = dayjs(state.dateRange[1]).format('YYYY-MM-DD')
  }
  fetchTicketList(params)
    .then((res) => {
      if (seq !== listRequestSeq) {
        return
      }
      const total = Number(res.data?.total ?? 0)
      const records = res.data?.records ?? []
      // 筛选后结果不足一页但 current>1 时，回到第 1 页重查（避免“有数据却空白”）
      if (total > 0 && current > 1 && records.length === 0) {
        state.current = 1
        state.filterVersion += 1
        return
      }
      applyTicketListResponse(res, statusFilter, statusType)
      state.loading = false
    })
    .catch((err) => {
      if (seq !== listRequestSeq) {
        return
      }
      console.log(err)
      state.loading = false
    })
}
const cancel = (sn) => {
  fetchOrderCancel({ orderSn: sn }).then((res) => {
    if (res.success) {
      message.success('订单取消成功')
      loadTicketList()
    } else {
      message.error(res.message)
    }
  })
}

const pay = (sn) => {
  router.push(`/order?sn=${sn}`)
}

const getActiveStatusFilter = () => {
  if (state.status === '' || state.status == null) return null
  const value = Number(state.status)
  return Number.isFinite(value) ? value : null
}

const filterRecordsByOrderStatus = (records, statusFilter, activeKey) => {
  if (statusFilter == null) return records ?? []
  if (activeKey === 2 && ARCHIVE_ONLY_STATUS_FILTER.includes(statusFilter)) {
    return (records ?? []).filter((info) => Number(info.archiveStatus) === statusFilter)
  }
  if (activeKey === 2) {
    return (records ?? []).filter(
      (info) =>
        Number(info.status) === statusFilter || Number(info.archiveStatus) === statusFilter
    )
  }
  return (records ?? []).filter((info) => Number(info.status) === statusFilter)
}

const buildDataSourceFromRecords = (records) => {
  let dataSource = []
  records.forEach((info) => {
    const hasReschedulablePassenger =
      info.status === 22
        ? (info.passengerDetails?.some((p) => {
            if (!p.updateTime) return true
            return !dayjs(p.updateTime).isSame(dayjs(), 'day')
          }) ?? false)
        : (info.passengerDetails?.some((p) => p.status === 3 || p.status === 23) ?? false)
    const hasRefundablePassenger =
      info.status === 22 || info.status === 36
        ? (info.passengerDetails?.some((p) => p.status === 22) ?? false)
        : (info.passengerDetails?.some((p) => p.status === 3 || p.status === 23) ?? false)
    info.passengerDetails?.forEach((item, index) => {
      dataSource.push({
        ...info,
        ...item,
        orderStatus: info.status,
        archiveStatus: info.archiveStatus,
        passengerStatus: item.status,
        hasReschedulablePassenger,
        hasRefundablePassenger,
        rowSpan: index === 0 ? info.passengerDetails.length : 0
      })
    })
  })
  return dataSource
}

const applyRowSpan = (dataSource) => {
  const orderSnGroups = new Map()
  dataSource.forEach((record, idx) => {
    if (!orderSnGroups.has(record.orderSn)) orderSnGroups.set(record.orderSn, [])
    orderSnGroups.get(record.orderSn).push(idx)
  })
  dataSource.forEach((record) => {
    record.rowSpan = 0
  })
  orderSnGroups.forEach((indices) => {
    if (indices.length > 0) dataSource[indices[0]].rowSpan = indices.length
  })
  return dataSource
}

watch(
  () => [state.activeKey, state.current, state.size, state.filterVersion],
  () => {
    loadTicketList()
  },
  { immediate: true }
)
const handleRefund = () => {
  const refundable = getRefundablePassengers(state.currentOrder)
  const refundableIdSet = new Set(refundable.map((p) => p.id))
  const selectedIds = state.refundOrder.filter((id) => refundableIdSet.has(id))
  if (!selectedIds.length) {
    message.warning('请选择可退票的乘车人')
    return
  }
  const refundType =
    selectedIds.length >= refundable.length ? 1 : 0
  fetchRefundTicket({
    orderSn: state.currentOrder,
    type: refundType,
    subOrderRecordIdReqList: selectedIds,
    feeSnapshot: buildRefundFeeSnapshot(
      state.refundFeeData,
      selectedIds,
      getRefundablePassengers(state.currentOrder)
    )
  }).then((res) => {
    state.visible = false
    if (res && res.success === false) {
      message.error(res.message || '退款失败')
      return
    }
    message.success('退款申请已提交')
    loadTicketList()
  })
}

/** 列表组排序权重：含已改签原单(32)的整组沉底 */
const getGroupSortWeight = (orderStatus) => {
  if (orderStatus === 32) return 2
  if (orderStatus === 31) return 1
  return 0
}

const normalizeOrderSn = (v) => (v == null ? '' : String(v).trim())

/** 取某 orderSn 在组内的订单元信息（取首行即可） */
const getOrderMetaInGroup = (groupRecords, orderSn) => {
  const row = groupRecords.find((r) => r.orderSn === orderSn)
  return {
    orderSn,
    vendOrder: row?.vendOrder,
    orderTime: row?.orderTime,
    orderStatus: row?.orderStatus ?? row?.status
  }
}

/** 原订单：orderSn 与 vendOrder 相同 */
const isOriginalOrderMeta = (meta) => {
  const sn = normalizeOrderSn(meta.orderSn)
  const vo = normalizeOrderSn(meta.vendOrder)
  return Boolean(sn && vo && sn === vo)
}

/** 改签子单：vendOrder 指向组内另一张单，且不等于自身 orderSn */
const isChildOrderMeta = (meta, groupOrderSns) => {
  const sn = normalizeOrderSn(meta.orderSn)
  const vo = normalizeOrderSn(meta.vendOrder)
  return Boolean(vo && sn && vo !== sn && groupOrderSns.includes(vo))
}

const buildOrderMetaMap = (dataSource) => {
  const map = new Map()
  dataSource.forEach((row) => {
    const sn = normalizeOrderSn(row.orderSn)
    if (!sn || map.has(sn)) return
    map.set(sn, getOrderMetaInGroup(dataSource, row.orderSn))
  })
  return map
}

const isOrderSnLinked = (metaA, metaB) => {
  const aSn = normalizeOrderSn(metaA.orderSn)
  const bSn = normalizeOrderSn(metaB.orderSn)
  if (aSn === bSn) return true
  const aVo = normalizeOrderSn(metaA.vendOrder)
  const bVo = normalizeOrderSn(metaB.vendOrder)
  if (aVo && aVo === bSn) return true
  if (bVo && bVo === aSn) return true
  return false
}

/** 确定组内原单 orderSn（置于最下方） */
const pickRootSnInGroup = (orderSns, groupRecords) => {
  const normalized = orderSns.map((sn) => normalizeOrderSn(sn))
  const explicit = orderSns.find((sn) =>
    isOriginalOrderMeta(getOrderMetaInGroup(groupRecords, sn))
  )
  if (explicit) return explicit

  const childSns = new Set(
    orderSns.filter((sn) =>
      isChildOrderMeta(getOrderMetaInGroup(groupRecords, sn), normalized)
    )
  )
  const nonChildren = orderSns.filter((sn) => !childSns.has(sn))
  if (nonChildren.length === 1) return nonChildren[0]

  const pointed = orderSns.filter((sn) =>
    orderSns.some((other) => {
      if (other === sn) return false
      const vo = normalizeOrderSn(getOrderMetaInGroup(groupRecords, other).vendOrder)
      return vo === normalizeOrderSn(sn)
    })
  )
  if (pointed.length) {
    const originalAmong = pointed.find((sn) =>
      isOriginalOrderMeta(getOrderMetaInGroup(groupRecords, sn))
    )
    if (originalAmong) return originalAmong
    return pointed.sort((a, b) => {
      const ta = dayjs(getOrderMetaInGroup(groupRecords, a).orderTime).valueOf() || 0
      const tb = dayjs(getOrderMetaInGroup(groupRecords, b).orderTime).valueOf() || 0
      return ta - tb
    })[0]
  }

  return orderSns[0]
}

/**
 * 同组内 orderSn 排序：改签子单按订票时间倒序在上，原单在最下
 */
const sortOrderSnInGroup = (orderSnSet, groupRecords) => {
  const orderSns = [...orderSnSet]
  if (orderSns.length <= 1) return orderSns

  const rootSn = pickRootSnInGroup(orderSns, groupRecords)
  const children = orderSns.filter((sn) => sn !== rootSn)
  children.sort((a, b) => {
    const ta = dayjs(getOrderMetaInGroup(groupRecords, a).orderTime).valueOf() || 0
    const tb = dayjs(getOrderMetaInGroup(groupRecords, b).orderTime).valueOf() || 0
    return tb - ta
  })

  return [...children, rootSn]
}

/**
 * 将 orderSn 与 vendOrder 关联的订单分为一组并排序（订单维度并查集）
 * 1. vendOrder === 他单 orderSn 或 他单 vendOrder === 本单 orderSn 为同组
 * 2. 原单：orderSn === vendOrder；组内子单在上、原单在最下
 * 3. 组间：含已改签原单(32)的组沉底，其余按组内最新 orderTime 倒序
 */
const groupAndSortOrders = (dataSource) => {
  if (!dataSource?.length) return dataSource

  const orderMetaMap = buildOrderMetaMap(dataSource)
  const orderMetas = [...orderMetaMap.values()]
  const parent = new Map(
    orderMetas.map((meta) => [normalizeOrderSn(meta.orderSn), normalizeOrderSn(meta.orderSn)])
  )

  const findParent = (sn) => {
    const key = normalizeOrderSn(sn)
    if (parent.get(key) !== key) {
      parent.set(key, findParent(parent.get(key)))
    }
    return parent.get(key)
  }

  const unionOrderSn = (a, b) => {
    const ra = findParent(a)
    const rb = findParent(b)
    if (ra !== rb) parent.set(ra, rb)
  }

  for (let i = 0; i < orderMetas.length; i++) {
    for (let j = i + 1; j < orderMetas.length; j++) {
      if (isOrderSnLinked(orderMetas[i], orderMetas[j])) {
        unionOrderSn(orderMetas[i].orderSn, orderMetas[j].orderSn)
      }
    }
  }

  const rowsByOrderSn = new Map()
  dataSource.forEach((row, idx) => {
    if (!rowsByOrderSn.has(row.orderSn)) rowsByOrderSn.set(row.orderSn, [])
    rowsByOrderSn.get(row.orderSn).push({ ...row, originalIndex: idx })
  })

  const clusterMap = new Map()
  orderMetas.forEach((meta) => {
    const clusterKey = findParent(meta.orderSn)
    if (!clusterMap.has(clusterKey)) clusterMap.set(clusterKey, [])
    clusterMap.get(clusterKey).push(meta.orderSn)
  })

  const groupEntries = []
  clusterMap.forEach((orderSns) => {
    const uniqueSns = [...new Set(orderSns)]
    const groupRecords = []
    uniqueSns.forEach((sn) => {
      const rows = rowsByOrderSn.get(sn) || []
      groupRecords.push(...rows)
    })
    const orderedSns = sortOrderSnInGroup(uniqueSns, groupRecords)
    const rootSn = orderedSns[orderedSns.length - 1]
    const rootStatus = getOrderMetaInGroup(groupRecords, rootSn).orderStatus
    const maxWeight = getGroupSortWeight(rootStatus)
    const latestTime = Math.max(
      ...uniqueSns.map(
        (sn) => dayjs(getOrderMetaInGroup(groupRecords, sn).orderTime).valueOf() || 0
      )
    )
    const minOriginalIndex = Math.min(...groupRecords.map((r) => r.originalIndex))
    groupEntries.push({
      groupRecords,
      orderedSns,
      maxWeight,
      latestTime,
      minOriginalIndex
    })
  })

  groupEntries.sort((a, b) => {
    if (a.maxWeight !== b.maxWeight) return a.maxWeight - b.maxWeight
    if (a.latestTime !== b.latestTime) return b.latestTime - a.latestTime
    return a.minOriginalIndex - b.minOriginalIndex
  })

  const sortedDataSource = []
  groupEntries.forEach(({ groupRecords, orderedSns }) => {
    orderedSns.forEach((orderSn) => {
      sortedDataSource.push(...groupRecords.filter((r) => r.orderSn === orderSn))
    })
  })

  const orderSnGroups = new Map()
  sortedDataSource.forEach((record, idx) => {
    if (!orderSnGroups.has(record.orderSn)) orderSnGroups.set(record.orderSn, [])
    orderSnGroups.get(record.orderSn).push(idx)
  })

  sortedDataSource.forEach((record) => {
    record.rowSpan = 0
  })
  orderSnGroups.forEach((indices) => {
    if (indices.length > 0) sortedDataSource[indices[0]].rowSpan = indices.length
  })

  return sortedDataSource
}
</script>

<style lang="scss" scoped>
.card-container {
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #dfe8f6;
  background: linear-gradient(180deg, #fbfdff 0%, #f3f8ff 100%);
  padding: 6px;
}
.tips-txt {
  background: linear-gradient(180deg, #fffdf4 0%, #fff8e8 100%);
  border: 1px solid #ffe28b;
  border-radius: 12px;
  padding: 12px;
  margin-top: 16px;
  line-height: 1.8;
}

.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 96px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  /* //   padding: 16px; */
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

:deep(.ant-table-thead > tr > th) {
  background-color: #f4f8ff;
  color: #334155;
  font-weight: 600;
}

:deep(.ant-table-thead .ant-table-cell) {
  background-image: none;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #edf2fb;
}

:deep(.ant-table-tbody > tr:hover > td) {
  background: #f8fbff;
}

/* status=31 的订单行灰色样式 */
:deep(.row-reschedule-status) {
  background-color: #f5f5f5 !important;
}

:deep(.row-reschedule-status > td) {
  color: #999 !important;
  background-color: #f5f5f5 !important;
}

:deep(.ant-tabs-top > .ant-tabs-nav) {
  margin: 0;
  padding: 0 6px;
}

:deep(.ant-tabs-content-holder) {
  padding: 14px;
  background-color: #fff;
  border-radius: 0 0 10px 10px;
  box-sizing: border-box;
  background-image: none;
}

:deep(.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab) {
  border-radius: 10px 10px 0 0;
  border-color: #dce7f8;
  background: #f4f8ff;
}

:deep(.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active) {
  background: #fff;
  border-bottom-color: #fff;
}

:deep(.ant-pagination) {
  padding-top: 4px;
}

:deep(.custom-modal .ant-alert-warning) {
  background-color: #fff !important;
  border: none !important;
}

:deep(.refund-modal) {
  .ant-modal-header {
    padding: 12px 20px;
  }

  .ant-modal-body {
    padding: 14px 20px 18px;
  }
}

.refund-alert {
  margin-bottom: 12px;
  background: #fff !important;
  border: none !important;
  padding: 0 2px;

  :deep(.ant-alert-message) {
    font-size: 15px;
  }

  :deep(.ant-alert-description) {
    font-size: 12px;
    line-height: 1.5;
  }
}

.refund-modal-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.refund-passenger-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  width: 100%;
}

.refund-passenger-label {
  font-size: 14px;
  color: #334155;
  line-height: 1.5;
  white-space: nowrap;
  flex-shrink: 0;
}

.refund-passenger-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px 24px;
  flex: 1;
  min-width: 0;
}

.refund-passenger-empty {
  color: #999;
  margin-top: 8px;
  font-size: 13px;
}

.refund-fee-section {
  width: 100%;
  padding: 0;
}

.refund-fee-placeholder {
  padding: 12px 14px;
  border-radius: 4px;
  background: #f7f8fa;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

.refund-footer-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e8e0c8;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.5;
}

.refund-actions {
  width: 100%;
  justify-content: center;
  margin-top: 16px;
}

.filter-bar {
  border-radius: 12px;
  border: 1px solid #e4ecf8;
  background: #fbfdff;
}

.passenger-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.passenger-name {
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
}

.passenger-id-type {
  color: #64748b;
  font-size: 13px;
  white-space: nowrap;
}

.passenger-status {
  color: #334155;
  font-size: 13px;
  white-space: nowrap;
}

.disc-tag {
  margin-left: 6px;
  font-size: 12px;
}
</style>
